export default __webpack_public_path__ + "static/media/marker-SES.e21d172e.svg";